import React from "react"
import PropTypes from "prop-types"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"

// Shown once to a new user, after their address is in and before they start
// drawing. Explains what the Sector Map is for; it does not collect anything.
const OnboardingIntroModal = ({ isOpen, onStart, onSkip }) => (
  <Modal isOpen={isOpen} size="lg" centered backdrop="static">
    <ModalHeader tag="h4">Let's map your property</ModalHeader>
    <ModalBody>
      <p>
        SAGE can start you off with a rough, to-scale map of your land — your
        property boundary, buildings, and how the sun moves across it — so
        you&apos;re not drawing on a blank canvas.
      </p>
      <p className="mb-2">We&apos;ll go through this together, in order:</p>
      <ol style={{ paddingLeft: 18 }}>
        <li>Your property shape and buildings</li>
        <li>Sun, wind and water direction</li>
        <li>Zones of use — where you spend your time</li>
        <li>Garden areas</li>
        <li>The crops you want to grow</li>
        <li>Where those crops go</li>
      </ol>
      <p style={{ fontSize: 13, opacity: 0.75 }}>
        Nothing here is permanent — you can redraw anything, and the aerial photo
        is only a tracing guide that gets cleared when you&apos;re done.
      </p>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Button color="secondary" onClick={onSkip}>
          Skip for now
        </Button>
        <Button color="info" onClick={onStart}>
          Get started
        </Button>
      </div>
    </ModalBody>
  </Modal>
)

OnboardingIntroModal.propTypes = {
  isOpen: PropTypes.bool,
  onStart: PropTypes.func,
  onSkip: PropTypes.func,
}

export default OnboardingIntroModal
